import styled from "styled-components";

export const Mask = styled("div")`
  position: fixed;
  z-index: 10;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  backdrop-filter: blur(10px); /* Adjust blur amount as needed */

  & > * {
    height: auto;
  }
`;
